import axios from 'axios';
import fallbackLikya from '../data/events/likya-49w-rasyo-2026.json';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FALLBACK_EVENTS = [fallbackLikya];

export const eventSlug = (ev) => (ev?.slug || '').replace('/etkinlik/', '').replace(/^\/+|\/+$/g, '');
export const eventPath = (ev) => `/${eventSlug(ev)}`;

const templateFor = (ev) => {
  const slug = eventSlug(ev);
  return FALLBACK_EVENTS.find(
    (t) => eventSlug(t) === slug || (t.slugAliases || []).includes(slug),
  );
};

/** Eski kayıtlarda olmayan alanları ve eski slug'ı paket içindeki şablondan tamamlar. */
const withTemplateDefaults = (ev) => {
  const tpl = templateFor(ev);
  if (!tpl) return ev;
  const legacyTopics = (ev.talkGroups || []).flatMap((g) => g.topics || []);
  return {
    ...ev,
    slug: eventSlug(tpl),
    talks: ev.talks?.topics?.length
      ? ev.talks
      : { ...tpl.talks, topics: tpl.talks?.topics?.length ? tpl.talks.topics : legacyTopics },
  };
};

/** Events coming from the admin panel; falls back to the bundled JSON. */
export const fetchEvents = async () => {
  try {
    const { data } = await axios.get(`${API}/events`);
    if (Array.isArray(data) && data.length > 0) return data.map(withTemplateDefaults);
  } catch (_) {}
  return FALLBACK_EVENTS;
};

export const fetchEventBySlug = async (slug) => {
  try {
    const { data } = await axios.get(`${API}/events/${slug}`);
    if (data?.name) return withTemplateDefaults(data);
  } catch (_) {}
  const tpl = templateFor({ slug });
  if (tpl) return tpl;
  // Eski slug ile gelinmişse yayındaki kayıtlar içinde ara
  try {
    const { data } = await axios.get(`${API}/events`);
    const match = (data || []).find((e) => eventSlug(withTemplateDefaults(e)) === slug);
    if (match) return withTemplateDefaults(match);
  } catch (_) {}
  return null;
};
